// https://github.com/baianat/vee-validate
// 示例页面：https://codesandbox.io/s/y3504yr0l1?initialpath=%2Fform&module=%2Fsrc%2Fcomponents%2FForm.vue
// 框架自带验证规则：https://baianat.github.io/vee-validate/guide/rules.html
import Vue from 'vue'
import VeeValidate, { Validator as _validator } from 'vee-validate'
import zhCN from 'vee-validate/dist/locale/zh_CN'
// import en from 'vee-validate/dist/locale/en'

// 重写extend方法
let extend = _validator.extend
_validator.extend = function (name, options) {
  extend(name, {
    validate: options.validate
  })
  //   let locale = {};
  //   for (let i in options.messages) {
  //     locale[i] = { messages: { [name]: options.messages[i] } };
  //   }
  let locale = {
    zh_CN: {
      messages: {
        [name]: options.messages['zh_CH']
      }
    },
    en: {
      messages: {
        [name]: options.messages['en']
      }
    }
  }
  _validator.localize(locale)
}

// 拓展验证器phone类型
_validator.extend('phone', {
  validate: value => /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value),
  messages: {
    zh_CH: field => `${field}格式错误`,
    en: field => `The ${field} value is not valid`
  }
})
// 数组长度必须大于0
_validator.extend('requiredArray', {
  validate: value => value.length > 0,
  messages: {
    zh_CH: field => `${field}不能为空`,
    en: field => `The ${field} is required`
  }
})
// 判断当前选择的数组必须大于1等于1（字段为选择的数据长度）
_validator.extend('selectArr', {
  validate: value => {
    return value > 0
  },
  messages: {
    zh_CH: field => `${field}`,
    en: field => `The ${field} value is not valid`
  }
})
// 拓展验证器email类型
_validator.extend('email', {
  validate: value => /^([a-zA-Z]|[0-9])(\w|)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value),
  messages: {
    zh_CH: field => `${field}格式错误`,
    en: field => `The ${field} value is not valid`
  }
})
// 拓展验证器用户名类型（可输入小写字母下划线和点）
_validator.extend('username', {
  validate: value => /^[a-z\d_ ]+$/.test(value),
  messages: {
    zh_CH: field => `${field}格式错误`,
    en: field => `The ${field} value is not valid`
  }
})
// 验证输入数据大于1

// _validator.extend('number', {
//   validate: value => /^[1-9]\d*$/.test(value),
//   messages: {
//     zh_CH: field => `${field}必须是一个大于0的整数`,
//     en: field => `The ${field} value is not valid`
//   }
// })

_validator.extend('discount', {
  validate: value => {
    return value > 0 && value < 10
  },
  getMessage: field => `${field}discount`,
  messages: {
    zh_CH: field => `${field}应大于0且小于10`,
    en: field => `The ${field} discount`
  }
})

_validator.extend('gtezero', {
  validate: value => {
    return value >= 0 && String(value).indexOf('.') < 0
  },
  messages: {
    zh_CH: field => `${field}必须是一个大于等于0的整数`,
    en: field => `The ${field} value is not valid`
  }
})
_validator.extend('morezero', {
  validate: value => value > 0,
  messages: {
    zh_CH: field => `${field}必须是一个大于0的数`,
    en: field => `The ${field} value is not valid`
  }
})
_validator.extend('moreequalzero', {
  validate: value => value >= 0,
  messages: {
    zh_CH: field => `${field}必须是一个大于等于0的数`,
    en: field => `The ${field} value is not valid`
  }
})
// usage in component
// this.$validator.validateAll().then(result => {
//   return new Promise((resolve, reject) => {
//     if (result) {
//       resolve(this.form);
//     } else {
//       reject();
//     }
//   });
// });
// 切换当前语言
// this.$validator.localize('ar');
// 错误信息：
// 为字段使用别名，data-vv-as="手机号码" ，如果不加data-vv-as,则在验证的错误信息中，将读取name属性，如，提示phone不能为空，设置别名后，提示手机号码不能为空
// <input type="text" name="phone"  data-vv-as="手机号码" v-model="form.phone" v-validate="'required|phone'" placeholder="请输入手机号码"/>
// 所有的错误信息都放在this.errors中通过例如this.errors.first('phone')来获取，其中phone为input的name属性值，不支持中文，这也是使用data-vv-as设置别名的原因
Vue.use(VeeValidate, {
  dictionary: {
    zh_CN: zhCN
    // en: en
  }
})
// 修改简体中文默认提示
// _validator.localize('zh_CN', {
//   messages: {
//     required: field => `请填写${field}`
//   }
// })

const dict = {
  zh_CN: {
    messages: {
      required: field => `请填写${field}`
    }
  }
}

_validator.localize(dict)

// 设置默认语言
_validator.localize('zh_CN')

export let Validator = _validator

export function validate (vm, form) {
  return vm.$validator.validateAll().then(result => {
    if (result) {
      return Promise.resolve(form)
    } else {
      vm.$message({
        message: vm.errors.items ? vm.errors.items[0].msg : '验证出现异常！',
        type: 'error'
      })
      return Promise.reject(vm.errors)
    }
  })
}
